import React from 'react';
import { Grid } from '@mui/material';
import getBaseEditor, { CommandPanels } from '../../BaseEditor';

const editorRenderer = (getControl) => (
  <Grid container spacing={2}>
    <Grid item sm={4}>
      {getControl('code')}
    </Grid>
    <Grid item sm={8}>
      {getControl('name')}
    </Grid>
  </Grid>
);

export default getBaseEditor(editorRenderer, '/api/catalog/stateproperties/', CommandPanels.catCommandPanel);
